/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function UsersIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke={props.stroke || '#7B8B9F'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="7" r="4" />
        <path d="M2 21v-1.5A4.5 4.5 0 0 1 6.5 15h5a4.5 4.5 0 0 1 4.5 4.5V21" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        <path d="M22 21v-1.5a4.5 4.5 0 0 0-3-4.24" />
      </g>
    </svg>
  );
}

export default UsersIcon;
